import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-delete-icon',
  templateUrl: 'delete-icon.component.html'
})
export class DeleteIconComponent {
  constructor() {}
}
